module.exports = __webpack_public_path__ + "static/media/maia.04f63458.jpg";